/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_ThreadInputs */

const zh_usage_thread = /** @type {(inputs: Usage_ThreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`详情`)
};

const en_usage_thread = /** @type {(inputs: Usage_ThreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Details`)
};

const es_usage_thread = /** @type {(inputs: Usage_ThreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalles`)
};

/**
* | output |
* | --- |
* | "Details" |
*
* @param {Usage_ThreadInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const usage_thread = /** @type {((inputs?: Usage_ThreadInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_ThreadInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_usage_thread(inputs)
	if (locale === "en") return en_usage_thread(inputs)
	return es_usage_thread(inputs)
});